import { render, staticRenderFns } from "./ReclamacionesComponent.vue?vue&type=template&id=79821ac2&scoped=true&"
var script = {}
import style0 from "./ReclamacionesComponent.vue?vue&type=style&index=0&id=79821ac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79821ac2",
  null
  
)

export default component.exports